import {useCallback} from 'react';

import {mergeAll} from 'ramda';

import {DmsDataGrid} from '@dms/shared';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

interface AvailabilitySegmentProps extends RequiredTestIdProps {
  manufacturerId: string | Nullish;
  manufacturerNumber: string | Nullish;
}

export function AvailabilitySegment(props: AvailabilitySegmentProps) {
  const queryModifier = useCallback(
    (filter: QueryFilterObject) =>
      mergeAll([
        filter,
        {
          articleId: undefined,
          manufacturerNumber: props.manufacturerNumber,
          manufacturer: props.manufacturerId,
          catalogNumber: undefined,
        },
      ]),
    [props.manufacturerNumber, props.manufacturerId]
  );

  return (
    <DmsDataGrid
      gridCode="warehouse-availability"
      queryModifier={queryModifier}
      autoHeight
      data-testid={suffixTestId('availability', props)}
    />
  );
}
